document.addEventListener("DOMContentLoaded", () => {
  document.documentElement.classList.add("js");

  // ─── 1. Nav drawer (opened by the burger) ───────────────────────────────
  const toggle = document.getElementById("nav-toggle");
  const drawer = document.getElementById("nav-drawer");
  const scrim = document.getElementById("nav-scrim");
  const closeBtn = document.getElementById("nav-close");

  const setDrawer = (open) => {
    if (!drawer) return;
    drawer.classList.toggle("is-open", open);
    if (scrim) scrim.classList.toggle("is-open", open);
    if (toggle) toggle.setAttribute("aria-expanded", open ? "true" : "false");
    document.body.style.overflow = open ? "hidden" : "";
    if (open && closeBtn) closeBtn.focus();
    else if (!open && toggle) toggle.focus();
  };

  if (toggle && drawer) {
    toggle.addEventListener("click", () => setDrawer(!drawer.classList.contains("is-open")));
  }
  if (closeBtn) closeBtn.addEventListener("click", () => setDrawer(false));
  if (scrim) scrim.addEventListener("click", () => setDrawer(false));

  // ─── 2. Sticky header — revealed when scrolling UP past the masthead ────
  const sticky = document.getElementById("sticky-header");
  const header = document.getElementById("site-header");
  if (sticky && header) {
    let lastY = window.pageYOffset;
    let ticking = false;
    const onScroll = () => {
      const y = window.pageYOffset;
      const show = y > header.offsetHeight + 40 && y < lastY;
      sticky.classList.toggle("is-visible", show);
      sticky.setAttribute("aria-hidden", show ? "false" : "true");
      lastY = y;
      ticking = false;
    };
    window.addEventListener("scroll", () => {
      if (!ticking) {
        window.requestAnimationFrame(onScroll);
        ticking = true;
      }
    }, { passive: true });
  }

  // ─── 3. Subscribe modal ─────────────────────────────────────────────────
  const modal = document.getElementById("formPopup");
  const setModal = (open) => {
    if (!modal) return;
    modal.hidden = !open;
    document.body.classList.toggle("wps-modal-open", open);
    if (open) {
      const field = modal.querySelector("input:not([type=hidden])");
      if (field) field.focus();
    }
  };
  document.querySelectorAll('[data-wps-modal-open], a[href="#formPopup"]').forEach((el) => {
    el.addEventListener("click", (e) => {
      e.preventDefault();
      setDrawer(false);
      setModal(true);
    });
  });
  document.querySelectorAll("[data-wps-modal-close]").forEach((el) => {
    el.addEventListener("click", () => setModal(false));
  });
  document.addEventListener("keydown", (e) => {
    if (e.key !== "Escape") return;
    if (modal && !modal.hidden) setModal(false);
    else if (drawer && drawer.classList.contains("is-open")) setDrawer(false);
  });

  // ─── 4. Back to top ─────────────────────────────────────────────────────
  const toTop = document.getElementById("to-top");
  if (toTop) {
    let ticking = false;
    window.addEventListener("scroll", () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          toTop.classList.toggle("is-visible", window.pageYOffset > 600);
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
    toTop.addEventListener("click", () => window.scrollTo({ top: 0, behavior: "smooth" }));
  }
});
